import React from "react"
import PropTypes from "prop-types"
import {
  SpacedLogoWhite,
} from "../../assets/images";
import "./SpacedPageLoader.scss"

class SpacedPageLoader extends React.Component {
  render() {
    const backgroundColor = {
      background: this.props.background
    }
    const loaderColor = {
      background: this.props.loaderColor
    }
    if (this.props.loading) {
      return (
        <div className="loading-background" style={backgroundColor}>
          <div className="loading-bar" >
            <div className="loading-circle-1" style={loaderColor} />
            <img src={SpacedLogoWhite} className="spaced-logo-small" alt="spaced-ventures-logo" />
            <div className="loading-circle-2" style={loaderColor} />
          </div>
        </div>
      )
    }
    return null
  }
}

SpacedPageLoader.defaultProps = {
  loading: false,
  background: "rgba(0, 0, 0, 1)",
  loaderColor: "#fff"
}

SpacedPageLoader.propTypes = {
  loading: PropTypes.bool,
  background: PropTypes.string,
  loaderColor: PropTypes.string
}

export default SpacedPageLoader